module.exports = __webpack_public_path__ + "img/EN-UK.aac0dfef.png";